"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteRefNumOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var QuoteRefNumOutputWidget = /** @class */ (function (_super) {
    __extends(QuoteRefNumOutputWidget, _super);
    function QuoteRefNumOutputWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuoteRefNumOutputWidget.prototype.render = function () {
        var quoteRefNum = this.props.engine.getInteraction()._id;
        var text = this.getSetting("shortWording") ? "Quote ref. no" : "Quote reference number";
        return ((0, jsx_runtime_1.jsxs)("p", { className: "quote-ref-num-output", children: [text, ": ", (0, jsx_runtime_1.jsx)("span", { className: "ref-num", children: quoteRefNum })] }));
    };
    QuoteRefNumOutputWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "shortWording", type: journey_model_1.TypeDescriptions.Boolean }
        ])
    ], QuoteRefNumOutputWidget);
    return QuoteRefNumOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.QuoteRefNumOutputWidget = QuoteRefNumOutputWidget;
//# sourceMappingURL=QuoteRefNumOutputWidget.js.map